export const unitRegex = /([0-9]+) ([a-zA-Z]+)/;
export const balanceRegex = /([0-9]+(?:\.[0-9]+)?)(?: ?([a-zA-Z]*))?/;
